import React from 'react'
import Text from '../../../../components/Text'
import Button from '../../../../components/ButtonNew'
import ArrowRightIcon from '../../../../components/Icons/ArrowRight'

const RejectedDocumentCard = ({ onViewDocuments }) => {
  return (
    <div className="bg-white rounded-[20px] p-5 z-20 -mt-16 relative border-2 border-[#FDA29B] space-y-4">
      <div className="space-y-1">
        <Text tag="p" variant="title" size="large" className="text-[#F04438]">
          There seems to be some problem with the uploaded document(s)
        </Text>
        <Text tag="p" variant="body" size="medium" className="text-[#5A6774]">
          Your document(s) have been rejected by the care navigator. Re-upload
          to get started with your Anaya journey.
        </Text>
      </div>
      <div className="pt-1">
        <Button fullWidth onClick={onViewDocuments}>
          View & Re-upload Doc(s)
          <ArrowRightIcon />
        </Button>
      </div>
    </div>
  )
}

export default RejectedDocumentCard
